<div class="login-page">
  <div class="login-brand">
    <div class="logo-icon"><mat-icon>business</mat-icon></div>
    <div>
      <strong>Trusted Technologies</strong>
      <p>HR &amp; Enterprise Platform</p>
    </div>
  </div>

  <mat-card class="login-card">
    <h1>Reset password</h1>
    <p class="subtitle">Choose a new password for your account.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Reset token</mat-label>
        <input matInput formControlName="token" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>New password</mat-label>
        <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Confirm password</mat-label>
        <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
      </mat-form-field>

      @if (error()) { <div class="error-banner">{{ error() }}</div> }
      @if (message()) { <div class="success-banner">{{ message() }}</div> }

      <button mat-raised-button color="primary" class="full-width submit-btn" type="submit" [disabled]="loading() || form.invalid">
        @if (loading()) { <mat-spinner diameter="22"></mat-spinner> } @else { Reset password }
      </button>
    </form>

    <div class="auth-links">
      <a routerLink="/login">Back to sign in</a>
    </div>
  </mat-card>
</div>
